import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-1" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "section"
}
const _hoisted_5 = { class: "name-grid" }

import { ref, toRefs, watch } from 'vue';
import { EMIT } from '@/enum';

interface ReferralInterface {
  id: number;
  service_provider_id: number | null;
  index: number;
  student_name: string;
  page: number;
}

interface PropsInterface {
  referrals: ReferralInterface[];
  open: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserArchiveReferral',
  props: {
    referrals: {},
    open: { type: Boolean }
  },
  emits: [EMIT.CANCEL, EMIT.SAVE, 'update-referrals'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { referrals, open } = toRefs(props);

const referralsArray = ref<ReferralInterface[]>([...referrals.value]);

watch(referrals, (newReferrals) => (referralsArray.value = [...newReferrals]));

const onCancel = () => emit(EMIT.CANCEL);

const onArchive = () => emit(EMIT.SAVE);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_unref(open))
    ? (_openBlock(), _createBlock(_component_ConfirmAction, {
        key: 0,
        header: "Archive Referral Students",
        "accept-label": "Archive",
        onAccept: onArchive,
        onCancel: onCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Icon, {
                  name: "warning",
                  class: "flex-1 p-1 text-primary-800"
                })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-1 p-2" }, "Are you sure you want to archive the following students?", -1))
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "mb-3 mt-3" }, "This action will:"),
              _createElementVNode("ol", null, [
                _createElementVNode("li", null, "Remove all future events for these students"),
                _createElementVNode("li", null, "Remove all connections to their Service Providers"),
                _createElementVNode("li", null, "Remove access to the system for these students (if applicable)"),
                _createElementVNode("li", null, "Set the archive reason as Inactive")
              ])
            ], -1)),
            (_unref(referrals).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(referrals), (referral) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: referral.id,
                        class: "name-item"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(referral.student_name) + " (Page " + _toDisplayString(referral.page) + ")", 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})